export default "__VITE_ASSET__555eb6bd__"